import React from 'react'

const localeContext = React.createContext({
  availableLocales: [],
  locale: '',
})

export default localeContext
